import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import Top from '../pages/users/Top';
import Shops from '../pages/users/Shops';
import Shop from '../pages/users/Shop';
import UserSignUp from '../pages/users/SignUp';
import UserLogin from '../pages/users/Login';
import AccountActivation from '../pages/users/AccountActivation';
import Dashboard from '../pages/users/Dashboard';
// import OwnerSignUp from '../pages/owners/SignUp';
// import OwnerLogin from '../pages/owners/Login';
import CafeNote from '../pages/users/CafeNote';
import RequestDraftShop from '../pages/users/RequestDraftShop';
import PasswordResetReception from "../pages/users/PasswordResetReception";
import PasswordReset from "../pages/users/PasswordReset";
import Profile from "../pages/users/Profile";
import CreateCafeNote from "../pages/users/CreateCafeNote";
import EditCafeNote from "../pages/users/EditCafeNote";
import RequestShops from "../pages/users/RequestShops";
import RequestShop from "../pages/users/RequestShop";
import NotFound from "../pages/NotFound";
import CafeNotes from "../pages/users/CafeNotes";
import PublicProfile from "../pages/users/PublicProfile";
import AdministratorLogin from "../pages/administrators/Login";
import AdministratorDashboard from "../pages/administrators/Dashboard";
import AdministratorCreateShop from "../pages/administrators/CreateShop";
import AdministratorEditShop from "../pages/administrators/EditShop";
import AdministratorShop from "../pages/administrators/Shop";
import AdministratorDraftShops from "../pages/administrators/DraftShops";
import AdministratorDraftShop from "../pages/administrators/DraftShop";
import PublicCafeNote from "../pages/users/PublicCafeNote";
import AdministratorUsers from "../pages/administrators/Users";

const router = createBrowserRouter([
  // ビジターユーザー
  { path: '/', element: <Top /> },
  { path: '/shops', element: <Shops /> },
  { path: '/shops/:id', element: <Shop /> },
  { path: '/user/sign-up', element: <UserSignUp /> },
  { path: '/user/login', element: <UserLogin /> },
  { path: '/user/public-profile/:username', element: <PublicProfile /> },
  // NOTE: ログインユーザー
  { path: '/user/dashboard', element: <Dashboard /> },
  { path: '/user/shops/draft/request', element: <RequestDraftShop /> },
  { path: '/user/password-reset-reception', element: <PasswordResetReception /> },
  { path: '/user/password-reset', element: <PasswordReset /> },
  { path: '/user/profile', element: <Profile /> },
  { path: '/user/cafe-notes/:id', element: <CafeNote /> },
  { path: '/user/cafe-notes', element: <CafeNotes /> },
  { path: '/user/cafe-notes/create', element: <CreateCafeNote /> },
  { path: '/user/cafe-notes/:id/edit', element: <EditCafeNote /> },
  { path: '/user/request-shops', element: <RequestShops /> },
  { path: '/user/public-cafe-notes/:id', element: <PublicCafeNote /> },
  { path: '/user/activation', element: <AccountActivation /> },
  { path: '/user/request-shops/:id', element: <RequestShop /> },
  // NOTE: オーナー
  // { path: '/owner/sign-up', element: <OwnerSignUp /> },
  // { path: '/owner/login', element: <OwnerLogin /> },
  // NOTE: 管理者
  { path: '/administrator/login', element: <AdministratorLogin /> },
  { path: '/administrator/dashboard', element: <AdministratorDashboard /> },
  { path: '/administrator/create-shop', element: <AdministratorCreateShop /> },
  { path: '/administrator/edit-shop/:id', element: <AdministratorEditShop /> },
  { path: '/administrator/shops/:id', element: <AdministratorShop /> },
  { path: '/administrator/draft-shops', element: <AdministratorDraftShops /> },
  { path: '/administrator/draft-shops/:id', element: <AdministratorDraftShop /> },
  { path: '/administrator/users', element: <AdministratorUsers /> },
  // NOTE: エラーページ
  { path: '*', element: <NotFound /> },
]);

export default router;
